import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const LucasApp = () => {

  const history = useNavigate();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.href = 'https://luc4s.dev';
    }, 0);

    return () => clearTimeout(redirectTimeout);
  }, [history]);

  return (<></>);
}
